module.exports = __webpack_public_path__ + "static/media/double-chevron-right.a6e5137e.svg";